<ui-message-custom class="font-md d-block message-block"
                   *ngIf="hasNotes">
  <div *ngIf="deliveryNoteForCustomer"
       class="note-offset-top delivery-note-text"
       [innerHTML]="deliveryNoteForCustomer">
  </div>

  <div *ngIf="productsWithUnavailableDays?.length > 0"
       class="note-offset-top">
    <span [translate]="'orderProcess.delivery.unavailableDays.note'">
        Note:
    </span>

    <ng-container *ngFor="let product of productsWithUnavailableDays"
                  [ngTemplateOutlet]="productInfoTmp"
                  [ngTemplateOutletContext]="{item: product}">
    </ng-container>
  </div>
</ui-message-custom>

<ng-template #productInfoTmp let-item="item">
  <span class="fw-bold"> {{ item.name }} </span>
  <span [translate]="'orderProcess.delivery.unavailableDays.isUnavailableOn'">
        is unavailable on
    </span>
  <span *ngFor="let day of item.daysUnavailable; let i=index">
        {{ getDayNameKey(day) | translate }}{{ i < item.daysUnavailable.length - 1 ? ', ' : '.' }}
    </span>
</ng-template>
